<div class="manage-notice-types">
  <a routerLink="/notices">< Notices </a>

  <h2>Manage notice types</h2>
  <button class="ui primary button notice-action-btn" (click)="addNoticeType()">
    Add Notice Type
  </button>

  <div>
    @if (isLoading) {
    <div class="loading">
      <div class="ui active centered inline loader"></div>
    </div>
    } @if (noticeTypeList && noticeTypeList.length > 0 ) {
    <table class="ui celled striped table">
      <thead>
        <tr>
          <th>Notice Type</th>
          <th>Display Name</th>
          <th>Notice Type Group</th>
          <th>Source</th>
          <th>Template Type</th>
          <th>Actions</th>
        </tr>
      </thead>
      @for (noticeType of noticeTypeList; track noticeType) {
      <tr>
        <td>{{ noticeType.name }}</td>
        <td>{{ noticeType.displayName }}</td>
        <td>{{ groupLabelMapping[noticeType.group] }}</td>
        <td>{{ noticeType.source }}</td>
        <td>{{ templateTypeList[noticeType.templateTypeId] }}</td>
        <td>
          <a (click)="updateNoticeType(noticeType)">Update</a>
        </td>
      </tr>
      }
    </table>

    }
  </div>
</div>
